// src/services/notification.js

let messageApi = null
let modalApi = null
let isInitialized = false

export const initNotification = (messageInstance, modalInstance) => {
    if (!messageInstance || !modalInstance) {
        console.warn('⚠️ Notification init called with invalid instances')
        return
    }
    
    messageApi = messageInstance
    modalApi = modalInstance
    isInitialized = true
    //console.log('✅ Notification API initialized successfully')
}

export const showMessage = (type, content, duration = 3) => {
    if (!isInitialized || !messageApi) {
        console.warn(`⚠️ Message API not initialized - cannot show ${type}: ${content}`)
        // Fallback per development
        if (process.env.NODE_ENV === 'development') {
            console.log(`📢 [${type.toUpperCase()}] ${content}`)
        }
        return
    }
    
    try {
        messageApi[type](content, duration)
    } catch (error) {
        console.error(`❌ Error showing ${type} message:`, error)
    }
}

export const showError = (content, duration = 5) => showMessage('error', content, duration)
export const showSuccess = (content, duration = 3) => showMessage('success', content, duration)
export const showWarning = (content, duration = 4) => showMessage('warning', content, duration)
export const showInfo = (content, duration = 3) => showMessage('info', content, duration)
export const showLoading = (content, duration = 0) => showMessage('loading', content, duration)

export const showModal = (config) => {
    if (!isInitialized || !modalApi) {
        console.warn('⚠️ Modal API not initialized')
        if (process.env.NODE_ENV === 'development') {
            console.log('📢 [MODAL]', config)
        }
        return null
    }
    
    try {
        return modalApi.confirm(config)
    } catch (error) {
        console.error('❌ Error showing modal:', error)
        return null
    }
}

export const destroyMessage = () => {
    if (messageApi) {
        messageApi.destroy()
    }
}

export const isNotificationReady = () => isInitialized && messageApi !== null

// API completa per retrocompatibilità
const notification = {
    init: initNotification,
    error: showError,
    success: showSuccess,
    warning: showWarning,
    info: showInfo,
    loading: showLoading,
    modal: showModal,
    destroy: destroyMessage,
    isReady: isNotificationReady,
}

export default notification